module.exports = __webpack_public_path__ + "img/home.f03974a0.svg";